/**
 * Tickets — the ticket engine's own queue (SupportCase domain), in the Inbox
 * panel beside the conversation queues it escalates out of.
 *
 * This is the product's Tickets: wherever the engine's flag is on, the legacy
 * conversation-lens Tickets group is hidden (see `tickets.js`), so the two rows
 * never both claim the name. The internal names — the `Cases` item names, the
 * `SUPPORT_CASES` i18n namespace, the `/cases` routes — stay as they are; they
 * are not user-facing and renaming them would only churn URLs and keys.
 *
 * The three views are query params on the single `support_cases_index` route
 * (`caseListQuery.js`), so each child is a deep link that survives a reload and
 * declares the query subset that identifies it. "All" carries no query, which
 * makes it the fallback the open workroom (`cases/:displayId`, a path segment
 * below the list) lights up — hence `activePathPrefix` on it and not on the
 * narrowed views, whose query the workroom URL does not carry.
 */
import { OWNER_SCOPE } from 'dashboard/helper/supportCaseMeta';

export default ({ t, accountScopedRoute, hasSupportCases }) => {
  if (!hasSupportCases) return null;

  return {
    name: 'Cases',
    label: t('SIDEBAR.CASES'),
    icon: 'i-ph-clipboard-text',
    children: [
      {
        name: 'Cases My Work',
        label: t('SUPPORT_CASES.VIEWS.MY_WORK'),
        icon: 'i-lucide-user',
        to: accountScopedRoute(
          'support_cases_index',
          {},
          { owner: OWNER_SCOPE.MINE }
        ),
        activeQuery: { owner: OWNER_SCOPE.MINE },
      },
      {
        name: 'Cases Unassigned',
        label: t('SUPPORT_CASES.VIEWS.UNASSIGNED'),
        icon: 'i-lucide-circle-dashed',
        to: accountScopedRoute(
          'support_cases_index',
          {},
          { owner: OWNER_SCOPE.UNASSIGNED }
        ),
        activeQuery: { owner: OWNER_SCOPE.UNASSIGNED },
      },
      {
        name: 'Cases All',
        label: t('SUPPORT_CASES.VIEWS.ALL'),
        icon: 'i-lucide-ticket',
        to: accountScopedRoute('support_cases_index'),
        activePathPrefix: true,
      },
    ],
  };
};
